import { cn } from "@/lib/utils"

// Book#stage, for KF admin's book pages.
export const BOOK_STAGE = {
  writing: { label: "Writing", className: "bg-zinc-50 text-zinc-700 border-zinc-200" },
  ready_to_assemble: { label: "Ready to assemble", className: "bg-sky-50 text-sky-800 border-sky-200" },
  assembled: { label: "Assembled", className: "bg-blue-50 text-blue-800 border-blue-200" },
  sent: { label: "Sent to print", className: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  unlocked: { label: "Unlocked for fix", className: "bg-amber-50 text-amber-800 border-amber-200" },
}

export function StageChip({ stage, className }) {
  const meta = BOOK_STAGE[stage] || BOOK_STAGE.writing
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap", meta.className, className)}>
      {meta.label}
    </span>
  )
}

export function formatDate(iso) {
  if (!iso) return ""
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
}
